import React from 'react';
import PropTypes from 'prop-types';
import { FaArrowRight } from '@react-icons/all-files/fa/FaArrowRight';
import LazyImage from '../../../../../hooks/lazy-image';
import Button from '../../../../atoms/button/button';
import { getAltText, imagePrettyUrl } from '../../../../../helpers/getters.mjs';
import useTranslate from '~hooks/useTranslate/useTranslate';
import styles from './template-one.module.scss';

export default function TemplateOne({
  module,
  scrollableContent = false,
  buttonType = 'secondary',
  buttonSize = 'm',
  width = '300',
  height = '176',
}) {
  const { items } = module;

  return (
    <div className={styles?.spotlightsImage || ''}>
      {
        // eslint-disable-next-line react/prop-types
        items?.map((res) => {
          const TitleTag = res?.title_tag || 'label';
          return (
            <div className={`${styles.item} ${scrollableContent && styles.scrollContent}`}>
              <div className={styles.topSection}>
                {res?.image && (
                  <LazyImage
                    width={width}
                    height={height}
                    src={imagePrettyUrl(res?.image, width, height)}
                    alt={getAltText(res?.image_object, res?.label)}
                  />
                )}
                {res?.label && <TitleTag>{res.label}</TitleTag>}
                {res.subtitle && <span>{res.subtitle}</span>}
                {res?.text && (
                  <div
                    tabIndex={`${scrollableContent ? 0 : -1}`}
                    className={`${styles.desc} ${scrollableContent ? styles.scroll : ''}`}
                    // eslint-disable-next-line react/no-danger
                    dangerouslySetInnerHTML={{ __html: res?.text }}
                  />
                )}
              </div>

              {res?.link?.value && (
                <Button
                  icon={<FaArrowRight />}
                  buttonType={buttonType}
                  buttonSize={buttonSize}
                  isInternalLink={res?.link?.type !== 'external'}
                  targetBlank={res?.link?.type !== 'page'}
                  to={res?.link?.value}
                  btnText={res?.link_text || useTranslate('read_review_spotlight', 'Read review')}
                />
              )}
            </div>
          );
        })
      }
    </div>
  );
}

TemplateOne.propTypes = {
  module: PropTypes.shape({
    items: PropTypes.shape({}),
  }).isRequired,
  scrollableContent: PropTypes.bool,
  buttonType: PropTypes.string,
  buttonSize: PropTypes.string,
  width: PropTypes.string,
  height: PropTypes.string,
};
